import VuSocialLogo from './VuSocialLogo';

export default VuSocialLogo;
